import React from 'react';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  number: number;
}
export function BonusCard({
  image,
  title,
  description,
  number
}: BonusCardProps) {
  return <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl overflow-hidden shadow-xl border border-blue-700 hover:border-amber-400/50 transition-colors duration-300" data-id="element-339">
      <div className="relative" data-id="element-340">
        <div className="absolute top-0 left-0 bg-amber-400 text-blue-900 font-bold px-4 py-1 rounded-br-lg z-10 shadow-md" data-id="element-341">
          BONO #{number}
        </div>
        <img src={image} alt={title} className="w-full h-48 object-cover md:h-56 opacity-90 hover:opacity-100 transition-opacity" data-id="element-342" />
      </div>
      <div className="p-6" data-id="element-343">
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-344">{title}</h3>
        <p className="text-blue-200" data-id="element-345">{description}</p>
        <div className="mt-4 inline-block text-xs font-semibold text-amber-400 border border-amber-400 px-2 py-1 rounded uppercase tracking-wider" data-id="element-346">
          Gratis por hoy
        </div>
      </div>
    </div>;
}